<template>
  <div class="row align-items-center">
    <div class="col row align-items-center">
      <slot name="title">
        <base-button type="primary" class="ml-2" size="sm" @click="$router.back()"
          ><i class="ni ni-bold-left mt-1"></i
        ></base-button>

        <span class="h3 mb-0 bg-tranparent">
          {{ title }}
        </span>
      </slot>
      <slot name="popover">
        <i
          v-if="popover"
          class="ri-information-line table-text ml-1"
          v-b-popover.hover.top="popover"
          variant="info"
        ></i>
      </slot>
    </div>
    <div class="col text-right">
      <slot name="button"></slot>
    </div>
  </div>
</template>
<script>
export default {
  inheritAttrs: false,
  name: "base-title",
  props: {
    title: {
      type: String,
      description: "Input label (text before input)",
    },
    popover: {
      type: String,
      description: "Input label (text before input)",
    },
  },
};
</script>